import React from "react";
import { useLocation, useParams } from "react-router-dom";
import { PAGE_IDS, PAGE_URLS } from "../../helpers/constants";
import { getValueOrBlank } from "../../helpers/utils";
import CreateProject from "../createProject/CreateProject";

const pageId = PAGE_IDS.EDIT_PROJECT;
const EditProject: React.FC = () => {
  const { id } = useParams();
  const location = useLocation();
  const tabValue = location.state?.tabValue ?? 0;
  const isNavigatedFromProgram =
    location?.state?.from === PAGE_URLS.EDIT_PROGRAM ||
    location?.state?.from === PAGE_URLS.VIEW_PROGRAM;

  return (
    <CreateProject
      pageId={pageId}
      isEditProject={true}
      projectId={getValueOrBlank(id)}
      tabValue={tabValue}
      isNavigatedFromProgram={isNavigatedFromProgram}
      pageUrl={PAGE_URLS.EDIT_PROJECT}
    />
  );
};

export default EditProject;
